import React, { useEffect, useState  } from 'react';
import toast from "react-hot-toast";
import {
    getQuotations,
    uploadDoc,
    downloadPDF
  } from "../../../../utils/api"

import InfiniteScroll from 'react-infinite-scroll-component';
import { useTable } from 'react-table';
import TableLoading from '../../../../components/TableLoading';
import {getToken} from '../../../../utils/tokenHelper'
import UploadQuotation from '../../../../components/modals/UploadQuotation';


function Quotation() {
    const rowLen = 10;
    const [hasMore, setHasMore] = useState(true);
    const [startIndex, setStartIndex] = useState(0);
    const [quotations, setQuotations] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [docName, setDocName] = useState('');
    const [docType] = useState('Quotation');
    const token = getToken();

    const columns = React.useMemo(
        () => [
            {
                id: "name",
                Header: 'Name',
                accessor: 'name',
            },
            {
                id: "net_total",
                Header: 'Net Total',
                accessor: 'net_total',
            },
            {
                id: "total_qty",
                Header: 'Total Qty',
                accessor: 'total_qty',
            },
            {
                id: "status",
                Header: 'Status',
                accessor: 'status',
            },
            {
                id: "viewquotation",
                Header: 'View Quotation',
                accessor: 'name',
            },
            {
                id: "viewpo",
                Header: 'Upload PO',
                accessor: 'name',
            },
        ], []
    );
    async function download_pdf(name){
        try{
            await downloadPDF(token, name, docType);
        }catch(err){
            let msg = `${docType} ${name} not found`;
            toast.error(msg, {position: 'top-center'});
        }
    }
    function modalCloseHandler(){
        setOpenModal(false)
    }
    async function uploadClickHandler(file){
        try{
            let formData = new FormData();
            formData.append("file", file); 
            formData.append("doctype", docType); 
            formData.append("docname", docName); 
            // eslint-disable-next-line
            const res = await uploadDoc(token, formData);
            setOpenModal(false);
            toast.success("Document uploaded.", {position: 'top-center'});
        }catch(err){
            toast.error("Error occurred!", {position: 'top-center'});
        }
    }
    async function upload_pdf(name){
        setDocName(name)
        setOpenModal(true)
    }

    const tableInstance = useTable({ columns, data: quotations });
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

    async function loadInvoice() {
        try{
            const payload = {
                "name": "", //or "SAL-ORD-2023-00001",
                "start": 0,
                "length": parseInt(rowLen)
             }
             
            const res = await getQuotations(token, payload)
            const {quotations} = res;
            setQuotations(quotations);
            setStartIndex(startIndex+quotations.length)
            if(quotations.length < rowLen){
                setHasMore(false)
            }
        }catch(err){
            console.log(err)
        }
    }

    const fetchMoreData = () => {
        setTimeout(async () => {
            try{
                const payload = {
                    "name": "",
                    "start": parseInt(startIndex),
                    "length": parseInt(rowLen)
                 }
                 
                const res = await getQuotations(token, payload)
                const {quotations} = res;
                setQuotations((prevItems) => [
                    ...prevItems,
                    ...quotations,
                ]);
                setStartIndex(startIndex+quotations.length)
                if(quotations.length < rowLen){
                    setHasMore(false)
                }
            }catch(err){
                console.log(err)
            }
        }, 500);
    };

    useEffect(() => {
        loadInvoice()
    }, [])

    return (
        <section>
            <div className="row  mt-2 mb-5">
                <div id='scrollableDiv' style={{ height: '80vh', overflow: 'auto' }}>
                    <InfiniteScroll
                        dataLength={quotations.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={<TableLoading />}
                        scrollableTarget='scrollableDiv'
                    >
                        <table {...getTableProps()} className='table table-striped'>
                            <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>
                                        {column.render('Header')}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                                {rows.map((row, i) => {
                                    prepareRow(row);
                                    return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map((cell, k) => {
                                            if(k === 4){
                                                return(
                                                    <td {...cell.getCellProps()}>
                                                        <button onClick={() => download_pdf(cell.render('Cell').props.value)} className='btn btn-primary'> {`View Quotation`}</button>
                                                    </td>
                                                )
                                            }else if(k === 5){
                                                return(
                                                    <td {...cell.getCellProps()}>
                                                        <input type='file' hidden name="file" />
                                                        <button onClick={() => upload_pdf(cell.render('Cell').props.value)} className='btn btn-primary'> {`Upload PO`}</button>
                                                    </td>
                                                )
                                            }else{
                                                return(
                                                    <td {...cell.getCellProps()}>
                                                        {cell.render('Cell')}
                                                    </td>
                                                )
                                            }
                                        })}
                                    </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </InfiniteScroll>
                </div>
            </div>
            {openModal ? 
                <UploadQuotation
                    title={`Upload Quotation`}
                    openModal={openModal}
                    modalCloseHandler={modalCloseHandler}
                    uploadClickHandler={uploadClickHandler}
                />
                :
                <></>
            }
        </section>
    );
  }
  
export default Quotation;
